export let MODES = /*#__PURE__*/function (MODES) {
  MODES["DASHBOARD"] = "DASHBOARD";
  MODES["PRODUCT_BUILDER"] = "PRODUCT_BUILDER";
  return MODES;
}({});
export const HINTS = {
  [MODES.DASHBOARD]: 'These are the colors we will use to produce the design on your swag, so please make sure the colors are correct. If they are not, let us know the correct colors by inputting them below.',
  [MODES.PRODUCT_BUILDER]: 'Prices are heavily dependent on how many colors are in your print. The more colors, the more expensive.'
};
export const TEXT = {
  DO_THIS_LATER: 'Do this later',
  CONFIRM: 'Confirm'
};